import React from 'react';
import review from '../../../images/review.png';
import review_gray from '../../../images/review_gray.png';
import review_pink from '../../../images/review_pink.png';
import { Modal } from 'antd';

class ReviewPopup extends React.Component {
  render() {
    const { color, t } = this.props;
    const styles = {
      title: {
        marginBottom: 10,
        fontSize: 16,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        textAlign: 'center',
        marginTop: 20
      },
      button: {
        margin: '0 auto',
        backgroundColor: color,
        color: 'white',
        border: 'none',
        borderRadius: '20px',
        width: 200,
        textAlign: 'center',
        marginTop: 20,
        cursor: 'pointer',
        padding: 10,
        marginBottom: 20
      },
      text: {
        marginBottom: 60,
        fontSize: 14,
        fontFamily: 'Arial Rounded MT Bold',
        color: color,
        textAlign: 'center',
        cursor: 'pointer'
      }
    };

    let image;
    if (color == '#F190AC') {
      image = review_pink;
    } else if (color == '#7c868d') {
      image = review_gray;
    } else {
      image = review;
    }

    return (
      <Modal
        footer={false}
        visible={this.props.open}
        onCancel={this.props.close}
        width={450}>
        <img
          src={image}
          style={{
            maxWidth: 150,
            margin: '0 auto',
            display: 'block',
            marginTop: 40
          }}
        />
        <h3 style={styles.title}>
          Review everything that you've completed so far to help you reflect on
          what you've learned, how you've learned it and how you have changed.
        </h3>
        <div onClick={() => this.props.close()} style={styles.button}>
          Done
        </div>
        <h3 onClick={() => this.props.dontShow()} style={styles.text}>
          Don’t show me this again
        </h3>
      </Modal>
    );
  }
}

export default ReviewPopup;



// WEBPACK FOOTER //
// ./src/containers/StudentApp/components/reviewPopup.js